import { Link, LinkProps, useMatch } from "react-router-dom";

import { NavigationMenuLink, navigationMenuTriggerStyle } from "./ui/navigation-menu";

export default function NavigationMenuRouterLink({
    to,
    end = false,
    ...props
}: LinkProps & { to: string; end?: boolean }) {
    const isActive = useMatch({ path: to, end }) !== null;

    return (
        <NavigationMenuLink asChild active={isActive} className={navigationMenuTriggerStyle()}>
            <Link to={to} {...props} />
        </NavigationMenuLink>
    );
}
